import React, { useEffect } from 'react';
import { observer } from 'mobx-react';

import { UiModal } from 'shared/uikit-new';
import { useObservable } from 'shared/hooks';
import { ITaskModel, TaskModel } from 'shared/models/TaskTracker';

import { MdTaskTrackerTaskSave } from './components/MdTaskTrackerTaskSave';
import { MdTaskTrackerTaskShow } from './components/MdTaskTrackerTaskShow';

import './styles.scss';

type PropsType = {
    isOpened?: boolean;
    onClose?: () => void;
    onSaved?: (task: TaskModel) => void;
    onDeleted?: (task: TaskModel) => void;
    taskTrackerTask?: ITaskModel;
};

export const MdTaskTrackerTask = observer(function MdTaskTrackerTask({
    taskTrackerTask: taskTrackerTaskData = {},
    isOpened,
    onClose = () => undefined,
    onSaved = () => undefined,
    onDeleted = () => undefined,
}: PropsType) {
    const store = useObservable({
        state: 'show',
    });

    useEffect(() => {
        if(!isOpened || taskTrackerTaskData?.id === undefined) {
            return;
        }

        if (taskTrackerTaskData.id === 0) {
            store.set('state', 'save');
            return;
        }

        store.set('state', 'show');
    }, [taskTrackerTaskData.id, store, isOpened]);

    const handleChangeState = (state: string) => {
        store.set('state', state);
    };

    return (
        <UiModal
            isAside
            isOpened={isOpened}
            onClose={onClose}
            className={'modal-task-tracker-task'}
        >
            {store.state === 'save' && (
                <MdTaskTrackerTaskSave
                    taskTrackerTask={taskTrackerTaskData}
                    onClose={onClose}
                    onChangeState={handleChangeState}
                    onSaved={(taskTrackerTask) => {
                        store.set('state', 'show');
                        onSaved(taskTrackerTask);
                    }}
                />
            )}
            {store.state === 'show' && (
                <MdTaskTrackerTaskShow
                    taskTrackerTask={taskTrackerTaskData}
                    onClose={onClose}
                    onChangeState={handleChangeState}
                    onSaved={(taskTrackerTask) => {
                        onSaved(taskTrackerTask);
                    }}
                    onDeleted={(taskTrackerTask) => {
                        onDeleted(taskTrackerTask);
                        onClose();
                    }}
                />
            )}
        </UiModal>
    );
});
